import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { LocalStorageService } from '../../../services/infrastructure/local-storage.service';

import { CommonService } from './../../../services/common/common.service';
import { LolLoggerService } from './../../../common/shared/lol-logger.service';
import { MasterConstants } from '../../../common/constants/master-constants';
import { AuthenticationService } from '../../../services/common/authentication.service';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit, OnDestroy {
  private subscription = new Array<Subscription>();
  counter: number = 1;
  constructor(private commonService: CommonService, private localStorageService: LocalStorageService,
    private authenticationSerivce: AuthenticationService) { }

  ngOnInit() {
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    };

    if (localStorage.headerCompanyCode) {
      const companyCode = JSON.parse(localStorage.headerCompanyCode);
      let evolveAccess = undefined;
      evolveAccess = JSON.parse(localStorage.evolveAccess).resultData.find(x => x.userIdCompanyCode == companyCode);

      let userId = '', emulationUserId = '';
      const evolveAccountRestriction = evolveAccess.evolveAccountRestriction;

      if (evolveAccess.isEmulationSet) {
        userId = evolveAccess.loggedUserId;
        emulationUserId = evolveAccess.userId;
      }
      else {
        userId = evolveAccess.userId;
      }

      setInterval(() => {
        this.counter = this.counter + 1;
        if (this.counter > 2) {
          this.subscription.push(this.commonService.signOut(userId, evolveAccountRestriction, companyCode, emulationUserId).subscribe((result: any) => {
            if (result) {
              this.localStorageService.clear();
              this.localStorageService.set(MasterConstants.IS_LOGOUT, true);
              let urlRef = '';
              this.subscription.push(this.authenticationSerivce.getOAuthSettings(urlRef).subscribe(response => {
                if (response) {
                  let url = `${response.oAuthEndSessionURL}?TargetResource=${response.redirectURI}`;
                  window.location.href = url;
                }
              }, (error => {
                LolLoggerService.info('Failed To Get OAuthSettings');
                LolLoggerService.error(error);
              })));
            }
          }, error => LolLoggerService.error(error)));
        }
      }, 1000);
    }
  }

  public ngOnDestroy(): void {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }
}
